// import React from "react";
// import DomainChip from "./DomainChip";

// const ParsedTextWithLinks = ({ text }) => {
//   const regex = /(\*\*[^*]+\*\*|\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))/g;

//   const elements = [];
//   let lastIndex = 0;
//   let match;

//   while ((match = regex.exec(text)) !== null) {
//     const [fullMatch, boldMatch, label, url] = match;

//     // Add plain text before the match
//     if (match.index > lastIndex) {
//       const plainText = text.slice(lastIndex, match.index);
//       elements.push(plainText);
//     }

//     if (boldMatch && !url) {
//       // Bold formatting
//       elements.push(
//         <strong key={`bold-${match.index}`}>{boldMatch.slice(2, -2)}</strong>
//       );
//     } else if (url) {
//       // Link using DomainChip
//       elements.push(<DomainChip key={`link-${match.index}`} url={url} />);
//     }

//     lastIndex = regex.lastIndex;
//   }

//   // Add remaining text after the last match
//   if (lastIndex < text.length) {
//     elements.push(text.slice(lastIndex));
//   }

//   // return <span>{elements}</span>;
//   return <span>{elements.length > 0 ? elements : text}</span>;
// };

// export default ParsedTextWithLinks;

// import React from "react";
// import DomainChip from "./DomainChip";

// const ParsedTextWithLinks = ({ text }) => {
//   const regex =
//     /(\*\*[^*]+\*\*|_(?:[^_]+)_|\*(?:[^*]+)\*|\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|\[?(?:source|Source):\s*<([^>]+)>\]?|(https?:\/\/[^\s)]+))/g;

//   const elements = [];
//   let lastIndex = 0;
//   let match;

//   while ((match = regex.exec(text)) !== null) {
//     const [
//       fullMatch,
//       styleMatch, // bold or italic block
//       label,
//       mdUrl,
//       sourceUrl,
//       rawUrl,
//     ] = match;

//     // Add plain text before the match
//     if (match.index > lastIndex) {
//       elements.push(text.slice(lastIndex, match.index));
//     }

//     if (styleMatch?.startsWith("**")) {
//       // Bold
//       elements.push(
//         <strong key={`bold-${match.index}`}>{styleMatch.slice(2, -2)}</strong>
//       );
//     } else if (styleMatch?.startsWith("*") || styleMatch?.startsWith("_")) {
//       // Italic
//       elements.push(
//         <em key={`italic-${match.index}`}>{styleMatch.slice(1, -1)}</em>
//       );
//     } else if (mdUrl) {
//       // Markdown link
//       elements.push(<DomainChip key={`md-${match.index}`} url={mdUrl} />);
//     } else if (sourceUrl) {
//       // Source: <abc.com> — strip [] and prepend https if missing
//       const normalized = sourceUrl.startsWith("http")
//         ? sourceUrl
//         : `https://${sourceUrl}`;
//       elements.push(
//         <React.Fragment key={`source-${match.index}`}>
//           <span style={{ marginRight: "4px" }}>Source:</span>
//           <DomainChip url={normalized} />
//         </React.Fragment>
//       );
//     } else if (rawUrl) {
//       // Raw URL
//       elements.push(<DomainChip key={`raw-${match.index}`} url={rawUrl} />);
//     }

//     lastIndex = regex.lastIndex;
//   }

//   if (lastIndex < text.length) {
//     elements.push(text.slice(lastIndex));
//   }

//   return <span>{elements.length > 0 ? elements : text}</span>;
// };

// export default ParsedTextWithLinks;

// import React from "react";
// import DomainChip from "./DomainChip";

// const ParsedTextWithLinks = ({ text }) => {
//   // Updated regex: allows optional surrounding parentheses before/after Markdown links
//   const regex =
//     /(\*\*[^*]+\*\*|_(?:[^_]+)_|\*(?:[^*]+)\*|\(?\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)\)?|\[?(?:source|Source):\s*<([^>]+)>\]?|(https?:\/\/[^\s)]+))/g;

//   const elements = [];
//   let lastIndex = 0;
//   let match;

//   while ((match = regex.exec(text)) !== null) {
//     const [
//       fullMatch,
//       styleMatch, // bold or italic block
//       label,
//       mdUrl,
//       sourceUrl,
//       rawUrl,
//     ] = match;

//     // Add plain text before the match
//     if (match.index > lastIndex) {
//       elements.push(text.slice(lastIndex, match.index));
//     }

//     if (styleMatch?.startsWith("**")) {
//       // Bold
//       elements.push(
//         <strong key={`bold-${match.index}`}>{styleMatch.slice(2, -2)}</strong>
//       );
//     } else if (styleMatch?.startsWith("*") || styleMatch?.startsWith("_")) {
//       // Italic
//       elements.push(
//         <em key={`italic-${match.index}`}>{styleMatch.slice(1, -1)}</em>
//       );
//     } else if (mdUrl) {
//       // Markdown link — now supports ([label](url)) too
//       elements.push(<DomainChip key={`md-${match.index}`} url={mdUrl} />);
//     } else if (sourceUrl) {
//       // Source: <abc.com> — prepend https if missing
//       const normalized = sourceUrl.startsWith("http")
//         ? sourceUrl
//         : `https://${sourceUrl}`;
//       elements.push(
//         <React.Fragment key={`source-${match.index}`}>
//           <span style={{ marginRight: "4px" }}>Source:</span>
//           <DomainChip url={normalized} />
//         </React.Fragment>
//       );
//     } else if (rawUrl) {
//       // Raw URL
//       elements.push(<DomainChip key={`raw-${match.index}`} url={rawUrl} />);
//     }

//     lastIndex = regex.lastIndex;
//   }

//   if (lastIndex < text.length) {
//     elements.push(text.slice(lastIndex));
//   }

//   return (
//     <div className="" style={{ marginLeft: "5px" }}>
//       {elements.length > 0 ? elements : text}
//     </div>
//   );
// };

// export default ParsedTextWithLinks;

import React from "react";
import DomainChip from "./DomainChip";

const ParsedTextWithLinks = ({ text }) => {
  // Below component is Useful in parsing sources in below format:
  // - **bold**
  // - *italic* / _italic_
  // - [label](url) and ([label](url))
  // - [https://a.com; https://b.com]
  // - Source: <url>
  // - raw https://url
  const regex =
    /(\*\*[^*]+\*\*|_(?:[^_]+)_|\*(?:[^*]+)\*|\(?\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)\)?|\[(https?:\/\/[^\]]+)\]|\[?(?:source|Source):\s*<([^>]+)>\]?|(https?:\/\/[^\s)\];]+))/g;

  const elements = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const [
      fullMatch,
      styleMatch,
      label,
      mdUrl,
      groupedSources,
      sourceUrl,
      rawUrl,
    ] = match;

    // Plain text before match
    if (match.index > lastIndex) {
      elements.push(text.slice(lastIndex, match.index));
    }

    if (styleMatch?.startsWith("**")) {
      // Bold
      elements.push(
        <strong key={`bold-${match.index}`}>{styleMatch.slice(2, -2)}</strong>
      );
    } else if (styleMatch?.startsWith("*") || styleMatch?.startsWith("_")) {
      // Italic
      elements.push(
        <em key={`italic-${match.index}`}>{styleMatch.slice(1, -1)}</em>
      );
    } else if (mdUrl) {
      // Markdown link
      elements.push(<DomainChip key={`md-${match.index}`} url={mdUrl} />);
    } else if (groupedSources) {
      // [https://a.com; https://b.com; ...]
      groupedSources
        .split(";")
        .map((u) => u.trim())
        .filter(Boolean)
        .forEach((url, idx) => {
          elements.push(
            <DomainChip key={`grouped-${match.index}-${idx}`} url={url} />
          );
        });
    } else if (sourceUrl) {
      // Source: <abc.com>
      const normalized = sourceUrl.startsWith("http")
        ? sourceUrl
        : `https://${sourceUrl}`;

      elements.push(
        <React.Fragment key={`source-${match.index}`}>
          <span style={{ marginRight: "4px" }}>Source:</span>
          <DomainChip url={normalized} />
        </React.Fragment>
      );
    } else if (rawUrl) {
      // Raw URL
      elements.push(<DomainChip key={`raw-${match.index}`} url={rawUrl} />);
    }

    lastIndex = regex.lastIndex;
  }

  // Remaining text
  if (lastIndex < text.length) {
    elements.push(text.slice(lastIndex));
  }

  return (
    <div style={{ marginLeft: "5px" }}>
      {elements.length > 0 ? elements : text}
    </div>
  );
};

export default ParsedTextWithLinks;
